import { render, staticRenderFns } from "./SubscriptionForm.Purchase.Test.vue?vue&type=template&id=e4742644&scoped=true&"
import script from "./SubscriptionForm.Purchase.Test.vue?vue&type=script&lang=js&"
export * from "./SubscriptionForm.Purchase.Test.vue?vue&type=script&lang=js&"
import style0 from "./SubscriptionForm.Purchase.Test.vue?vue&type=style&index=0&id=e4742644&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4742644",
  null
  
)

export default component.exports